import './Navbar.styles.scss';

const Navbar = () => {
  return (
    <>
      <div className="nav-bar">
        <img className="logo" src="https://www.mediaferry.com/wp-content/uploads/2024/07/Mediaferry-logo-full-white.png" alt="mediaferry logo, that says mediaferry" />
        <h3 className="heading-text">PDF Scraper.</h3>
      </div>
    </>
  );
};

export default Navbar;
